import { render, staticRenderFns } from "./work_users_block.vue?vue&type=template&id=02faef5c&scoped=true&"
import script from "./work_users_block.vue?vue&type=script&lang=js&"
export * from "./work_users_block.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02faef5c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02faef5c')) {
      api.createRecord('02faef5c', component.options)
    } else {
      api.reload('02faef5c', component.options)
    }
    module.hot.accept("./work_users_block.vue?vue&type=template&id=02faef5c&scoped=true&", function () {
      api.rerender('02faef5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_imc/memorandum/inside/action/components/work_users_block.vue"
export default component.exports